export default __webpack_public_path__ + "static/media/Floodlight.4ee600fa.png";